MdEditor.fp-input-text(v-model='textModel.value' language='fr-FR' :preview='false' :toolbars='toolbars' :footers='footers' @on-change='onTextChange' :noUploadImg='true' :class='{"-touched": touched}' :disabled='disabled')
